<template>
  <page heading="Terms of Service"></page>
</template>

<script>
import Page from '../../layouts/Page/Page';

export default {
  name: 'TermsOfService',
  components: {
    Page
  }
};
</script>
